import styled from 'styled-components'
import {Link} from 'react-router-dom'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import SearchIcon from '@material-ui/icons/Search'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat'
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects'

const PageContainer = styled.main`
	width: 100%;
	padding: 0;
	margin: 0;
`

const HeroSection = styled.div`
	background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
		url('/assets/ed_crisis.webp') center top/cover;
	background-attachment: fixed;
	min-height: 400px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	padding: 60px 40px;
	text-align: center;
	margin-bottom: 60px;

	@media (max-width: 768px) {
		min-height: 300px;
		padding: 40px 20px;
		margin-bottom: 40px;
		background-attachment: scroll;
	}
`

const HeroContent = styled.div`
	// max-width: 900px;

	h1 {
		font-size: 3rem;
		font-weight: 700;
		margin-bottom: 24px;
		text-transform: none;
		color: white;
		line-height: 1.2;

		@media (max-width: 768px) {
			font-size: 2rem;
		}
	}

	p {
		font-size: 1.1rem;
		line-height: 1.8;
		margin: 0;
		color: rgba(255, 255, 255, 0.95);

		@media (max-width: 768px) {
			font-size: 1rem;
		}
	}
`

const ContentSection = styled.section`
	margin: 0 2vw 40px 2vw;

	@media (max-width: 768px) {
		margin: 0 2vw 20px 2vw;
	}
`

const StepsContainer = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
	flex-wrap: nowrap;
	overflow-x: auto;
	padding: 0 0 16px 0;

	@media (max-width: 968px) {
		flex-wrap: wrap;
		justify-content: center;
	}

	@media (max-width: 600px) {
		flex-direction: column;
		gap: 16px;
	}
`

const CardWrapper = styled.div`
	flex: 1 1 calc(20% - 12px);
	// min-width: 140px;
	// max-width: 200px;

	@media (max-width: 1400px) {
		// min-width: 130px;
		// max-width: 180px;
	}

	@media (max-width: 1200px) {
		flex: 1 1 calc(33.333% - 8px);
		// min-width: 120px;
		// max-width: 160px;
	}

	@media (max-width: 968px) {
		flex: 1 1 calc(50% - 8px);
		// min-width: 150px;
		// max-width: 250px;
	}

	@media (max-width: 600px) {
		flex: 1 1 100%;
		min-width: unset;
		max-width: unset;
	}
`

const SectionTitle = styled.h2`
	font-size: 2rem;
	font-weight: 700;
	text-align: center;
	margin-bottom: 60px;
	color: #d32f2f;
	text-transform: none;
	text-decoration: underline;

	@media (max-width: 768px) {
		font-size: 1.6rem;
		margin-bottom: 40px;
	}
`

const StepCard = styled(Card)`
	&.MuiCard-root {
		height: 100%;
		display: flex;
		flex-direction: column;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		border-radius: 8px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
		background-color: #fafafa;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
			// cursor: pointer;
		}
	}
`

const StepCardContent = styled(CardContent)`
	&.MuiCardContent-root {
		text-align: center;
		padding: 24px 16px;
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`

const IconWrapper = styled.div`
	background-color: #f0f0f0;
	border-radius: 50%;
	width: 64px;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 16px;

	.MuiSvgIcon-root {
		font-size: 32px;
		color: #999999;
	}
`

const StepTitle = styled(Typography)`
	&.MuiTypography-root {
		font-size: 1rem;
		font-weight: 700;
		margin-bottom: 8px;
		color: #333333;
		text-transform: none;
	}
`

const StepDescription = styled(Typography)`
	&.MuiTypography-root {
		font-size: 0.85rem;
		color: #777777;
		line-height: 1.5;
	}
`

const CTASection = styled.div`
	text-align: center;
	margin-top: 60px;

	@media (max-width: 768px) {
		margin-top: 40px;
	}
`

const CTAButton = styled(Button)`
	&.MuiButton-root {
		background-color: #0ec0e2;
		color: white;
		padding: 12px 28px;
		font-size: 0.95rem;
		font-weight: 600;
		border-radius: 40px;
		text-transform: none;
		box-shadow: 0 3px 10px rgba(2, 113, 217, 0.3);
		transition: all 0.3s ease;

		&:hover {
			background-color: #03aaccff;
			box-shadow: 0 5px 14px rgba(2, 113, 217, 0.4);
			transform: translateY(-2px);
		}

		@media (max-width: 768px) {
			padding: 10px 20px;
			font-size: 0.9rem;
		}
	}
`

const steps = [
	{
		icon: <SearchIcon />,
		title: 'Explore Projects',
		description: `Discover past projects done by Fellows and Alumni. Browse impactful initiatives across cities. Learn from project plan and key insights to inspire your own ideas.`,
	},
	{
		icon: <AddCircleOutlineIcon />,
		title: 'Create New Project',
		description: `Start your own project and define its vision. Share it with your co-fellows through the portal by saving your project here`,
	},
	{
		icon: <TrendingFlatIcon />,
		title: 'Carry Forward Project',
		description: `Carry forward a project you want to continue. Take forward a project from past cohorts. Access past data, learnings, and progress to scale its reach and sustain the impact.`,
	},
	{
		icon: <EmojiObjectsIcon />,
		title: 'Next Steps Resources',
		description: `Find resources, FAQs and different options. Go through the helpful guides to explore ways to strengthen your project journey.`,
	},
]

export default function LandingPage() {
	return (
		<PageContainer>
			<HeroSection>
				<HeroContent>
					<h1>Nurturing Every Project: Be The Change</h1>
					<p>
						Thousands of past projects done by Fellows and Alumni
						have faded away with every passing cohort. Many are
						reborn under a different name, but only some manage to
						sustain over the years as legacy BTCPs or social
						enterprises. With the belief that every project is worth
						nurturing, we've developed the BTCP platform as an
						opportunity for everyone who leads BTCPs and everyone
						who wishes to leverage/support them to exchange
						information, resources, and more. For Fellow-led BTCPs,
						the platform and its offerings also serve as a means for
						the Training and Impact team to track and support
						project progress and completion effectively.
					</p>
				</HeroContent>
			</HeroSection>

			<ContentSection>
				<SectionTitle>
					How It Works: Your Journey with BTCP
				</SectionTitle>
				<StepsContainer>
					{steps.map((step, index) => (
						<CardWrapper key={index}>
							<StepCard>
								<StepCardContent>
									<IconWrapper>{step.icon}</IconWrapper>
									<StepTitle variant="h5">
										{step.title}
									</StepTitle>
									<StepDescription variant="body2">
										{step.description}
									</StepDescription>
								</StepCardContent>
							</StepCard>
						</CardWrapper>
					))}
				</StepsContainer>

				<CTASection>
					<CTAButton
						component={Link}
						to="/search"
						variant="contained"
						size="large"
					>
						Go To Dashboard to explore projects →
					</CTAButton>
				</CTASection>
			</ContentSection>
		</PageContainer>
	)
}
